import { Controller } from "@hotwired/stimulus"
import { createCIHotspotViewer } from "../lib/hotspot_pseudo_fullscreen"

export default class extends Controller {
  static values = {
    src: String,
    hotspots: { type: String, default: "[]" },
    side: { type: String, default: "front" }
  }

  connect() {
    if (!this.srcValue) return

    const hotspots = this.parseHotspots(this.hotspotsValue)

    const { viewer, cleanupPseudoFullscreen } = createCIHotspotViewer(this.element, {
      src: this.srcValue,
      alt: `${this.sideValue} device image`,
      zoom: true,
      trigger: "click",
      hotspots
    })

    this.viewer = viewer
    this.pseudoFullscreenCleanup = cleanupPseudoFullscreen
  }

  disconnect() {
    if (this.pseudoFullscreenCleanup) {
      this.pseudoFullscreenCleanup()
      this.pseudoFullscreenCleanup = null
    }

    if (this.viewer) {
      this.viewer.destroy()
      this.viewer = null
    }
  }

  parseHotspots(raw) {
    try {
      const parsed = typeof raw === "string" ? JSON.parse(raw) : raw
      return Array.isArray(parsed) ? parsed : []
    } catch {
      return []
    }
  }
}
